module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "FRONT.V"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rFRONT.V"
    }
  }, [_vm._v("V. Text and Versions")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Because of the importance of the Torah to Judaism, the Hebrew text of the Pentateuch, including that of the book of Numbers, is on the whole well preserved and free from problems.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.11.0023",
      "id": "FN.11.0023r"
    }
  }, [_vm._v("1")]), _vm._v(" Most of the textual difficulties "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.12"
    }
  }), _vm._v("arise in the poetic bits of ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21")]), _vm._v(" and in the Balaam oracles of chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22–24")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.12.0024",
      "id": "FN.12.0024r"
    }
  }, [_vm._v("2")]), _vm._v(" Since neither the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.135"
    }
  }, [_vm._v("Sam. Pent.")]), _vm._v(" nor the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" renders much help in reconstructing the original text of these passages, these textual problems are probably older than either of these versions (see below).")]), _vm._v(" "), _c('p', [_vm._v("The Masoretes produced a text ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(") that, with the exception of the above-named passages, shows little significant variation among the extant "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.8"
    }
  }, [_vm._v("mss")]), _vm._v(". At several points in the text of Numbers the Masoretes inserted readings or notes that are significant. The so-called "), _c('i', [_vm._v("special points")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("puncta extraordinaria")]), _vm._v(") mark particular words in the text to show Masoretic awareness of textual or doctrinal reservations about that word (or passage) in the tradition of their community.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.12.0025",
      "id": "FN.12.0025r"
    }
  }, [_vm._v("3")]), _vm._v("﻿ The "), _c('i', [_vm._v("inverted nuns")]), _vm._v(" that mark off "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:35–36")]), _vm._v(" probably show that these verses were considered to be out of place.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.12.0026",
      "id": "FN.12.0026r"
    }
  }, [_vm._v("4")]), _vm._v("﻿ The "), _c('i', [_vm._v("Sebir notes")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.6"
    }
  }, [_vm._v("Aram")]), _vm._v(". "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("s")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḇîr")]), _vm._v(", “supposed”) occur over twenty times in the book (and often elsewhere) and seem to be used as a sign that the marginal reading is the more usual or commonly occurring form.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.12.0027",
      "id": "FN.12.0027r"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', [_vm._v("The "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.135"
    }
  }, [_vm._v("Sam. Pent.")]), _vm._v(" is a different Hebrew recension from the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(", written in a special Hebrew script.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.12.0028",
      "id": "FN.12.0028r"
    }
  }, [_vm._v("6")]), _vm._v("﻿ The date of this recension is unknown; "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.13"
    }
  }), _vm._v("estimates range from the 4th to the 1st cent. B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" "), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0029",
      "id": "FN.13.0029r"
    }
  }, [_vm._v("7")]), _vm._v("﻿ The "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.135"
    }
  }, [_vm._v("Sam. Pent.")]), _vm._v(" differs from the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(" some 6,000 times, 1,900 of these in agreement with the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(". It is a full text in that it tends to expand on the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(", not only in the direction of giving special place to the theology of the Samaritan sect, but also in the direction of incorporation of readings from similar texts elsewhere in the OT into the text. In the book of Numbers the longest and perhaps most significant variants are additions from "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 1–3")]), _vm._v(" (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 1:6–8")]), _vm._v(" is inserted after "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 10:10")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 1:20–23a")]), _vm._v(" after "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 12:16")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0030",
      "id": "FN.13.0030r"
    }
  }, [_vm._v("8")]), _vm._v("﻿ Especially interesting are the interpolations from "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 2")]), _vm._v(" into the travel narrative of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 21")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0031",
      "id": "FN.13.0031r"
    }
  }, [_vm._v("9")]), _vm._v("﻿ These add bits of dialogue to the rather colorless "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(", but none of these readings should be considered original.")]), _vm._v(" "), _c('p', [_vm._v("The Pentateuch of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" (or Old Greek version) is usually dated in the 3rd cent. B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" "), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0032",
      "id": "FN.13.0032r"
    }
  }, [_vm._v("10")]), _vm._v("﻿ In Numbers, as in the rest of the Pentateuch, the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" offers for the most part a translation of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(" into idiomatic Greek.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0033",
      "id": "FN.13.0033r"
    }
  }, [_vm._v("11")]), _vm._v("﻿ Most of the variant readings in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" are in the spellings of names; in a few cases the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" order of verses differs from the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0034",
      "id": "FN.13.0034r"
    }
  }, [_vm._v("12")]), _vm._v("﻿ The "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" is quite frequently longer than the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(", but occasionally it is shorter.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0035",
      "id": "FN.13.0035r"
    }
  }, [_vm._v("13")]), _vm._v("﻿ While it is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.14"
    }
  }), _vm._v("possible that some "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" readings preserve a different (perhaps older) text tradition than the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(", each "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" reading must be assessed to determine this.")]), _vm._v(" "), _c('p', [_vm._v("The Qumran materials do not yield much in the way of significant textual variants.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.14.0036",
      "id": "FN.14.0036r"
    }
  }, [_vm._v("14")]), _vm._v("﻿ Most of what has been published consists of scattered words and lines of text, some of which show affinity with the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.135"
    }
  }, [_vm._v("Sam. Pent.")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" readings.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.14.0037",
      "id": "FN.14.0037r"
    }
  }, [_vm._v("15")]), _vm._v("﻿ A single "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.8"
    }
  }, [_vm._v("ms")]), _vm._v(". found in Cave 4 gives portions of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:30–4:14")]), _vm._v(" in a Greek version that generally follows the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" text, but with some variants.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.14.0038",
      "id": "FN.14.0038r"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', [_vm._v("The "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.2"
    }
  }, [_vm._v("Vulg")]), _vm._v(". on the book of Numbers was translated by St. Jerome sometime between A"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("D"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" 390 and about 405. Although Jerome undertook to translate the Hebrew OT rather than the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" into Latin, he also admitted to using the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" as well as the other Greek Versions (Aquila, Symmachus, and Theodotion). Scholars have also detected traces of the conclusions of some rabbinic exegesis in the translation. B. J. Roberts concluded his summary of the nature of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.2"
    }
  }, [_vm._v("Vulg")]), _vm._v(". OT in the following way:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Our conclusion, then, regarding the nature of Jerome’s translation is that, when due allowance is made for all external influecnes, it must be admitted that his method was neither straightforward nor consistent.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.14.0039",
      "id": "FN.14.0039r"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', [_vm._v("In sum, the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(" is generally preferable to the variant readings of "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.135"
    }
  }, [_vm._v("Sam. Pent.")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.2"
    }
  }, [_vm._v("Vulg")]), _vm._v("., or the Qumran materials. The translation in the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.15"
    }
  }), _vm._v("commentary below is based on the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(" and adheres to it as far as possible, although variants will be mentioned in the notes.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2363bd48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-nicot04nu-0013.vue
// module id = 90
// module chunks = 0